import React from 'react'
import { AutoComplete as AntAutocomplete, AutoCompleteProps } from 'antd'
import cl from 'classnames'

import styles from './styles.module.scss'

const AutoComplete: React.FC<AutoCompleteProps> = ({ className, ...props }) => {
	return (
		<AntAutocomplete
			{...props}
			getPopupContainer={
				props.getPopupContainer ? props.getPopupContainer : (trigger) => trigger.parentNode
			}
			popupClassName={cl(styles.autocompletePopup, props.popupClassName)}
			className={cl(styles.basicAutocomplete, className)}
		/>
	)
}

export default AutoComplete
